import { Variables } from "configs/variables";


export const downloadPresentation = () => {
  const downloadLink = document.createElement("a");
  const fileName = "Apresentação_Caju";

  downloadLink.href = Variables.presentationLink;
  downloadLink.setAttribute("download", fileName);
  downloadLink.target = "_blank";
  document.body.appendChild(downloadLink);
  downloadLink.click();
};
